__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-88f4f21b/_next/";